/**
 * Uploads in parts (ADR-0003): the BFF's `/api/uploads` protocol, with the same cookie auth and CSRF header as every
 * other call, and the limits the server states — the only limits this app knows.
 */
import { createHttpUploadClient, type UploadLimits } from '@evt/flow-stream-ui'
import { useQuery } from '@tanstack/react-query'
import { csrfCookie } from './portal-client'

export const uploadClient = createHttpUploadClient({
  basePath: '/api/uploads',
  decorateRequest: (init) => {
    const headers = new Headers(init.headers)
    const method = (init.method ?? 'GET').toUpperCase()
    if (method !== 'GET' && method !== 'HEAD') headers.set('X-CSRF-Token', csrfCookie())
    return { ...init, credentials: 'include', headers }
  },
  onUnauthorized: () => {
    if (location.pathname !== '/login') location.assign('/login')
  }
})

/** The server's upload limits. Null until they load; the server enforces them regardless. */
export function useUploadLimits(): UploadLimits | null {
  const q = useQuery({
    queryKey: ['uploads', 'limits'],
    queryFn: ({ signal }) => uploadClient.limits(signal),
    staleTime: 5 * 60_000
  })
  return q.data ?? null
}
